module.exports = __webpack_public_path__ + "img/steel.be5030ca.webp";